export default function PiCheckoutInfo({ amount, decimals = 4 }) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return null;

  const formatted = new Intl.NumberFormat(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(n);

  return (
    <div className="text-sm text-textPrimary" aria-label="Total you pay in Pi">
      🪙 You Pay{" "}
      <span className="font-semibold text-accent">{formatted} PI</span>
    </div>
  );
}
